module.exports = __webpack_public_path__ + "img/3.58fee64e.png";